import { AbstractControl, FormArray } from '@angular/forms';

export const filterFormArray = <T extends AbstractControl<unknown>>(
  formArray: FormArray<T>,
  filter: (t: T) => boolean,
) => {
  const count = formArray.length;
  for (let i = count - 1; i >= 0; i--) {
    if (!filter(formArray.controls.at(i) as T)) {
      formArray.removeAt(i);
    }
  }
};
